import { takeEvery, takeLatest } from 'redux-saga/effects';
import { MODULE_NAME } from '../constants';
import {
  LOAD_SESSION_LIST, LOAD_SESSION_ID, LOAD_SESSION_STATUS_LIST, CLOSE, PRINT, CREATE_RECOVERY_CODE,
} from '../actions';

import loadSessionList from './loadSessionList';
import loadSessionId from './loadSessionId';
import loadSessionStatusList from './loadSessionStatusList';
import closeSession from './closeSession';
import printLostTicket from './printLostTicket';
import createRecoveryCode from './createRecoveryCode';

export default function* sagas() {
  yield takeLatest(MODULE_NAME + LOAD_SESSION_LIST, loadSessionList);
  yield takeLatest(MODULE_NAME + LOAD_SESSION_ID, loadSessionId);
  yield takeEvery(MODULE_NAME + LOAD_SESSION_STATUS_LIST, loadSessionStatusList);
  yield takeEvery(MODULE_NAME + CLOSE, closeSession);
  yield takeEvery(MODULE_NAME + PRINT, printLostTicket);
  yield takeEvery(MODULE_NAME + CREATE_RECOVERY_CODE, createRecoveryCode);
}
